"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
var pubnub_1 = __importDefault(require("pubnub"));
var rxjs_1 = require("rxjs");
var constants_1 = require("../constants");
var log_factory_service_1 = require("./log-factory.service");
var services_1 = require("../generated/services");
var operators_1 = require("rxjs/operators");
var i0 = __importStar(require("@angular/core"));
var i1 = __importStar(require("./log-factory.service"));
var i2 = __importStar(require("../generated/services/messaging-client.service"));
exports.EventTypes = {
    engagement: 0,
    dmsPushResponse: 1
};
var NotificationService = /** @class */ (function () {
    function NotificationService(logFactory, messagingClient) {
        this.messagingClient = messagingClient;
        this.enabled = true;
        this.messageReceivedSubject = new rxjs_1.Subject();
        this.statusReceivedSubject = new rxjs_1.Subject();
        // default to enabled if the variable is not set
        this.enabled = (constants_1.Settings.environmentVariables.notificationServiceEnabled == null ||
            constants_1.Settings.environmentVariables.notificationServiceEnabled);
        this.log = logFactory.get('notificationService');
        this.message$ = this.messageReceivedSubject.asObservable();
        this.statusReceived = this.statusReceivedSubject.asObservable();
    }
    Object.defineProperty(NotificationService.prototype, "newPushResponse", {
        get: function () {
            return this.message$
                .pipe(operators_1.filter(function (evt) { return evt.eventType == exports.EventTypes.dmsPushResponse; }));
        },
        enumerable: true,
        configurable: true
    });
    NotificationService.prototype.connect = function () {
        return __awaiter(this, void 0, void 0, function () {
            var connectWithConfig, pubNubConfig, p, err_1;
            var _this = this;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (!this.enabled) {
                            // Not configured, do not connect
                            return [2 /*return*/, Promise.resolve()];
                        }
                        connectWithConfig = function (config) {
                            var pubnub = new pubnub_1.default({
                                subscribeKey: config.subscriptionKey,
                                authKey: config.authorizationKey,
                                ssl: true,
                                uuid: undefined //config.uuid,
                            });
                            pubnub.addListener({
                                message: function (msg) {
                                    _this.log.debug('received message:', msg);
                                    try {
                                        var parsedEvent = JSON.parse(msg.message);
                                        _this.messageReceivedSubject.next(parsedEvent);
                                    }
                                    catch (err) {
                                        _this.log.error('could not parse message property:', msg, err);
                                    }
                                },
                                status: function (status) {
                                    _this.log.debug('received status:', status);
                                    _this.statusReceivedSubject.next(status);
                                },
                            });
                            _this.log.debug('connecting');
                            pubnub.subscribe({
                                channels: config.channels || undefined,
                                channelGroups: config.channelGroups || undefined,
                            });
                            return pubnub;
                        };
                        _a.label = 1;
                    case 1:
                        _a.trys.push([1, 4, , 5]);
                        return [4 /*yield*/, this.messagingClient.GetPubNubConfigGET().toPromise()];
                    case 2:
                        pubNubConfig = _a.sent();
                        if (!pubNubConfig) {
                            this.log.debug('PubNub disabled');
                            return [2 /*return*/];
                        }
                        return [4 /*yield*/, connectWithConfig(pubNubConfig)];
                    case 3:
                        p = _a.sent();
                        this.pubnub = p;
                        return [3 /*break*/, 5];
                    case 4:
                        err_1 = _a.sent();
                        this.log.error('connection error:', err_1);
                        return [2 /*return*/];
                    case 5: return [2 /*return*/];
                }
            });
        });
    };
    NotificationService.ngInjectableDef = i0.ɵɵdefineInjectable({ factory: function NotificationService_Factory() { return new NotificationService(i0.ɵɵinject(i1.LogFactory), i0.ɵɵinject(i2.MessagingClientService)); }, token: NotificationService, providedIn: "root" });
    return NotificationService;
}());
exports.NotificationService = NotificationService;
